import { useEffect, useState } from "react";
import Common from "../../helper/common";
import { Button } from "../../components/ui/button";
import { Icon } from "@iconify/react";
import { AppSearchSelect } from "../../components/appComponents";
import AdvanceTable from "../../components/advanceTable";
import AddOffPeak from "./addoffpeaks";

const OffPeaks = () => {
  const [data, setData] = useState({});
  const [sportList, setSportList] = useState([]);
  const [sportId, setSportId] = useState(null);
  const [open, setOpen] = useState(false);
  const [refId, setRefId] = useState(null);

  useEffect(() => {
    if (!open && refId) {
      setRefId();
    }
  }, [open, refId]);

  useEffect(
    () => {
      getData(1);
      getSportList();
    },
    [sportId] // , fromDate, tillDate]
  );

  function toAmPmFormat(timeStr) {
    const [hour, minute] = timeStr.split(":").map(Number);
    const suffix = hour >= 12 ? "PM" : "AM";
    const adjustedHour = hour % 12 || 12;
    return `${adjustedHour}:${minute.toString().padStart(2, "0")} ${suffix}`;
  }

  const resetFilters = () => {
    setSportId(null);
  };

  const getData = async (
    pageNumber,
    searchTerm = "",
    recordsToDisplay = null
  ) => {
    const response = await Common.ApiService.getInstance().request(
      `GetQuickPatchList`,
      {
        pageNumber: pageNumber,
        q: searchTerm,
        isactive: true,
        recordsToDisplay,
        sportId: sportId,
      },
      "POST"
    );

    if (response?.data) {
      // debugger;
      let obj = {
        ...response.data[0],
        data: response.data[0].data.map((item) => ({
          ...item,
          type: item.type ?? "-",
          amount: item.amount ?? "-",
          sportName: item.sportName ?? "-",
          start: item.start == null ? "-" : toAmPmFormat(item.start),
          end: item.end == null ? "-" : toAmPmFormat(item.end),
        })),
      };

      setData(obj);
    }
  };

  const columns = [
    { title: "Amount/Hour", type: "number", isVisible: true, key: "amount" },
    { title: "Type", type: "number", isVisible: false, key: "type" },
    { title: "Start Hour", type: "time", isVisible: true, key: "start" },
    { title: "End Hour", type: "time", isVisible: true, key: "end" },
    // { title: "Club Id", type: "text", isVisible: true, key: "clubId" },
    // { title: "Sport Id", type: "text", isVisible: true, key: "sportId" },
    // { title: "Club", type: "date", isVisible: true, key: "" },
    { title: "Sport Name", type: "text", isVisible: true, key: "sportName" },
  ];

  const actions = [
    {
      type: "edit",
      onClick: (val) => _onEdit(val.id),
    },
    {
      type: "delete",
      onClick: (val) => _handleDelete(val.id),
    },
  ];

  const _onEdit = async (id) => {
    setOpen(true);
    setRefId(id);
  };

  const getSportList = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "GetClubSports"
      );
      const data = [{ id: null, name: "All" }, ...(response?.data ?? [])];

      setSportList(data);
    });
  };

  const _handleDelete = async (id) => {
    const isConfirmed = await Common.SweetAlert.confirmation(
      "Are you sure want to delete this Off Peak Pricing??",
      "Delete Off-Peak Pricing"
    );

    if (isConfirmed) {
      let resp = await Common.ApiService.getInstance().request(
        `DeleteQuickPatch?id=${id}`,
        {},
        "Delete"
      );

      Common.SweetAlert.alert(resp.message, "success");

      setTimeout(() => {
        getData(1);
      }, 500);
    }
  };

  const _addUpdateTrigger = () => {
    <Button size="icon" variant="outline" color="secondary" className="h-7 w-7">
      <Icon icon="heroicons:pencil" className="h-4 w-4" />
    </Button>;
  };

  return (
    <>
      <div className="md:grid md:grid-cols-6 gap-3 h-150 w-150 ">
        <AppSearchSelect
          value={sportId}
          onChange={setSportId}
          placeholder={"All"}
          label={"Sports"}
          data={sportList}
          className={"mb-3 col-span-1"}
        />
        <Button className="lg:mt-6 h-8 mb-5" onClick={resetFilters}>
          Reset Filter
        </Button>
      </div>

      {data?.data && (
        <AdvanceTable
          title={"Off Peak Pricing"}
          columns={columns.filter((item) => item.isVisible)}
          data={data}
          getData={getData}
          showPagination
          showAddButton
          actionButtons={actions}
          addButton={() => (
            <AddOffPeak
              id={refId}
              onClose={() => getData()}
              open={open}
              setOpen={setOpen}
            />
          )}
          updateTrigger={_addUpdateTrigger}
        />
      )}
    </>
  );
};

export default OffPeaks;
